<template>
  <div class="product-params">
    <div class="product-params__title">
      产品参数
    </div>
    <ul class="product-params__content">
      <li v-for="(item,index) in data" :key="index">
        <div>{{ item.attr_name }}</div>
        <div>{{ item.attr_value }}</div>
      </li>
    </ul>
    <div class="product-params__button">
      <button @click="close">完成</button>
    </div>
  </div>
</template>
<script>

export default {
  props: ['data'],
  mounted() {
    const height = document.body.clientHeight;
    const ele = document.getElementsByClassName('product-params__content');
    if (height < 500) {
      ele[0].style.maxHeight = `${height / 2}px`;
    } else {
      ele[0].style.maxHeight = `${height * 0.7}px`;
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
.product-params {
  height: 100%;

  &__title {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 36px;
    color: #4a4a4a;
    height: 50px;
    padding: 30px 0;
  }

  &__content {
    // max-height: calc(100vh - 6rem); 该写法会导致app内置浏览器和原生浏览器差别很大 因为vh不一样
    overflow-y: scroll;
    padding: 0 36px;

    li {
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);
      display: flex;
      padding: 30px 0;
      font-size: 28px;

      :first-child {
        width: 20%;
        color: #9b9b9b;
      }

      :last-child {
        width: 80%;
        padding-left: 20px;
        color: #000000;
        word-break: break-word;
      }
    }

    li:last-child {
      border: none;
    }
  }

  &__button {
    padding: 20px 36px;

    button {
      padding: 20px 0;
      width: 100%;
      font-size: 30px;
      color: #ffffff;
      background-image: linear-gradient(90deg, #fa841b 17%, #ff6002 85%);
      border-radius: 12px;
    }
  }
}
</style>
